"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    parseJson: function() {
        return parseJson;
    },
    stringifyJson: function() {
        return stringifyJson;
    }
});
function dateReviver(_key, value) {
    if (typeof value === 'string') {
        const a = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(Z|([+-])(\d{2}):(\d{2}))$/.exec(value);
        if (a) {
            return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]));
        }
    }
    return value;
}
function parseJson(text) {
    const parsed = JSON.parse(text, dateReviver);
    return parsed;
}
function stringifyJson(obj) {
    return JSON.stringify(obj);
}

//# sourceMappingURL=json.js.map